export enum Gender {
	FEMININO = 'FEMININO',
	MASCULINO = 'MASCULINO',
}
